"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/breakpoints.js":
/*!**************************************!*\
  !*** ./js/components/breakpoints.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  let currentBreakPoint = false;
  const breakpoints = [320, 375, 590, 768, 991, 1024, 1200, 1440, 1600, 1920, 3000];
  const currentInnerWidth = window.innerWidth;
  let index = 0;
  for (let breakpoint of breakpoints) {
    if (breakpoint >= currentInnerWidth) {
      if (index === 0) {
        currentBreakPoint = breakpoints[index];
      } else {
        currentBreakPoint = breakpoints[index - 1];
      }
      break;
    }
    index++;
  }
  if (!currentBreakPoint) currentBreakPoint = 768;
  return currentBreakPoint;
});

/***/ }),

/***/ "./js/components/constants.js":
/*!************************************!*\
  !*** ./js/components/constants.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DESKTOP_BREAKPOINT: () => (/* binding */ DESKTOP_BREAKPOINT),
/* harmony export */   DESKTOP_BREAKPOINT_EXTRA_LARGE: () => (/* binding */ DESKTOP_BREAKPOINT_EXTRA_LARGE),
/* harmony export */   DESKTOP_BREAKPOINT_LARGE: () => (/* binding */ DESKTOP_BREAKPOINT_LARGE),
/* harmony export */   DESKTOP_BREAKPOINT_MEDIUM: () => (/* binding */ DESKTOP_BREAKPOINT_MEDIUM),
/* harmony export */   TABLET_BREAKPOINT: () => (/* binding */ TABLET_BREAKPOINT)
/* harmony export */ });
const TABLET_BREAKPOINT = 767;
const DESKTOP_BREAKPOINT = 1024;
const DESKTOP_BREAKPOINT_MEDIUM = 1600;
const DESKTOP_BREAKPOINT_LARGE = 1920;
const DESKTOP_BREAKPOINT_EXTRA_LARGE = 3000;

/***/ }),

/***/ "./js/components/svelte-wrapper.js":
/*!*****************************************!*\
  !*** ./js/components/svelte-wrapper.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  const appContainer = document.querySelectorAll(container);
  return [...appContainer].map(appTarget => {
    const initialized = appTarget.dataset.initialized || false;
    let props = {};
    if (appTarget && !initialized) {
      if (propsEl) {
        props = json_6__WEBPACK_IMPORTED_MODULE_0___default().parse(appTarget.querySelector(propsEl)?.innerHTML) || {}; //get json from the script id 
      }
      //inject component into container
      const instance = new Component({
        target: appTarget,
        props: {
          shopifyData: props?.data //pass the prop on data prop as default
        }
      });
      appTarget.dataset.initialized = true;
      return instance;
    }
  });
});

/***/ }),

/***/ "./js/components/svelte/add-to-cart-bundle.svelte":
/*!********************************************************!*\
  !*** ./js/components/svelte/add-to-cart-bundle.svelte ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* js/components/svelte/add-to-cart-bundle.svelte generated by Svelte v4.2.8 */




function create_fragment(ctx) {
	let button;
	let html_tag;
	let t;
	let mounted;
	let dispose;

	return {
		c() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			html_tag = new svelte_internal__WEBPACK_IMPORTED_MODULE_0__.HtmlTag(false);
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("\n  Ajouter l’ensemble au panier");
			html_tag.a = t;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "class", "bundle_products_addToCart");
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, button, anchor);
			html_tag.m(/*svgIcon*/ ctx[0], button);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(button, t);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(button, "click", /*handleAddToCart*/ ctx[1]);
				mounted = true;
			}
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(button);
			}

			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { shopifyData } = $$props;

	const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                        <path d="M11 6.76668L5 3.30668M2.18001 5.14001L8.00001 8.50668L13.82 5.14001M8 15.22V8.50002M14 11.1667V5.83335C13.9998 5.59953 13.938 5.36989 13.821 5.16746C13.704 4.96503 13.5358 4.79692 13.3333 4.68002L8.66667 2.01335C8.46397 1.89633 8.23405 1.83472 8 1.83472C7.76595 1.83472 7.53603 1.89633 7.33333 2.01335L2.66667 4.68002C2.46418 4.79692 2.29599 4.96503 2.17897 5.16746C2.06196 5.36989 2.00024 5.59953 2 5.83335V11.1667C2.00024 11.4005 2.06196 11.6301 2.17897 11.8326C2.29599 12.035 2.46418 12.2031 2.66667 12.32L7.33333 14.9867C7.53603 15.1037 7.76595 15.1653 8 15.1653C8.23405 15.1653 8.46397 15.1037 8.66667 14.9867L13.3333 12.32C13.5358 12.2031 13.704 12.035 13.821 11.8326C13.938 11.6301 13.9998 11.4005 14 11.1667Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`;

	const curatedProducts = shopifyData.map(id => {
		return {
			id,
			quantity: 1,
			properties: { _fromBundle: true }
		};
	});

	const handleAddToCart = async () => {
		const url = "/cart/add.js";
		const body = { "items": curatedProducts };

		const headers = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body)
		};

		const response = await fetch(url, headers);
		const data = await response.json();
		window.location.href = "/cart";
	};

	$$self.$$set = $$props => {
		if ('shopifyData' in $$props) $$invalidate(2, shopifyData = $$props.shopifyData);
	};

	return [svgIcon, handleAddToCart, shopifyData];
}

class Add_to_cart_bundle extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, { shopifyData: 2 });
	}

	get shopifyData() {
		return this.$$.ctx[2];
	}

	set shopifyData(shopifyData) {
		this.$$set({ shopifyData });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Add_to_cart_bundle, {"shopifyData":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Add_to_cart_bundle);

/***/ })

}]);